import type { Ref } from 'vue'
import { startG1WallClock } from '@lucimark/shared/helpers/g1WallClock'
import { onBeforeUnmount, ref, watch } from 'vue'

export function useG1WallClock(active: Ref<boolean>, locale?: Ref<string | undefined>) {
  const clockLabel = ref('')
  const clockIso = ref(new Date().toISOString())

  let stop: (() => void) | null = null

  function start() {
    stop?.()
    stop = startG1WallClock((label) => {
      const now = new Date()
      clockLabel.value = label
      clockIso.value = now.toISOString()
    }, { getLocale: () => locale?.value })
  }

  function stopClock() {
    stop?.()
    stop = null
  }

  watch(active, (on) => {
    if (on) {
      start()
    }
    else {
      stopClock()
    }
  }, { immediate: true })

  onBeforeUnmount(stopClock)

  return { clockLabel, clockIso }
}
